import {
  COMMISSIONS_GET_NEW_MONTH_BEGIN,
  COMMISSIONS_GET_NEW_MONTH_SUCCESS,
  COMMISSIONS_GET_NEW_MONTH_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_GET_NEW_MONTH_BEGIN:
      return {
        ...state,
        getNewCommissionMonthPending: true
      }
    case COMMISSIONS_GET_NEW_MONTH_SUCCESS:
      return {
        ...state,
        getNewCommissionMonthPending: false,
        getNewCommissionMonthSuccess: true,
        newCommissionMonth: action.data,
        getNewCommissionMonthError: null
      }
    case COMMISSIONS_GET_NEW_MONTH_FAILURE:
      return {
        ...state,
        getNewCommissionMonthPending: false,
        getNewCommissionMonthError: action.data
      }
    default:
      return state
  }
}
